import * as React from "react"

function LaptopIcon({...props}) {
  return (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 19 17"
        {...props}
    >
      <path
        data-name="Path 12"
        d="M17.5 12.5h-16a1 1 0 01-1-1v-10a1 1 0 011-1h16a1 1 0 011 1v10a1 1 0 01-1 1z"
        fill="#1f9ed6"
      />
      <path
        data-name="Path 13"
        d="M17.5 12.5h-16a1 1 0 01-1-1v-2h18v2a1 1 0 01-1 1z"
        fill="#e7f0f3"
      />
      <path
        data-name="Path 14"
        d="M11 17H8a.472.472 0 01-.5-.5v-4A.472.472 0 018 12h3a.472.472 0 01.5.5v4a.472.472 0 01-.5.5zm-2.5-1h2v-3h-2z"
        fill="#010101"
      />
      <path
        data-name="Rectangle 5"
        fill="#d8e5ea"
        d="M7.759 12.742h3.153v3.783H7.759z"
      />
      <circle
        data-name="Ellipse 1"
        cx={0.631}
        cy={0.631}
        r={0.631}
        transform="translate(9.02 10.22)"
        fill="#010101"
      />
      <path
        data-name="Path 15"
        d="M17.5 0h-16A1.473 1.473 0 000 1.5v10A1.473 1.473 0 001.5 13h6v3H4.75a.5.5 0 000 1h9.5a.5.5 0 000-1H11.5v-3h6a1.473 1.473 0 001.5-1.5v-10A1.473 1.473 0 0017.5 0zM1 1.5a.472.472 0 01.5-.5h16a.472.472 0 01.5.5V9H1zM10.5 16h-2v-3h2zm7.5-4.5a.472.472 0 01-.5.5h-16a.472.472 0 01-.5-.5V10h17z"
        fill="#010101"
      />
    </svg>
  )
}

export default LaptopIcon